import { render, staticRenderFns } from "./studentExaminationRecord.vue?vue&type=template&id=7707a366&scoped=true&"
import script from "./studentExaminationRecord.vue?vue&type=script&lang=js&"
export * from "./studentExaminationRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7707a366",
  null
  
)

export default component.exports